import { render, staticRenderFns } from "./ListProdukGroup.vue?vue&type=template&id=40769c48"
import script from "./ListProdukGroup.vue?vue&type=script&lang=js"
export * from "./ListProdukGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports